<template>
  <UApp>
    <!-- Håller standardmönstret: NuxtLayout + NuxtPage -->
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
    
    
    <NuxtRouteAnnouncer />
  </UApp>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { useCatalogStore } from '@/store/catalog'
import { useRuntimeConfig, useRouter } from '#app'
import { usePlausible } from '@/composables/usePlausible'

const colorMode = useColorMode()
const router = useRouter()
const { trackPageview } = usePlausible()

const catalogStore = useCatalogStore()
const config = useRuntimeConfig()
const sheetId = computed(() => config.public.googleSheetId)

onMounted(() => {
  console.log("%c Made by Hjärtat - https://hjartat.net",
    "background: #000; color: #fff; display:block; padding:5px 10px;")
  console.log("%c App version: " + config.public.appVersion,
    "background: #000; color: #fff; display:block; padding:5px 10px;")
  console.log("%c If someone tells you that you have enough bicycles and you don't need more, stop talking to them. You don't need that kind of negativitiy in your life.", "background: #e0307f; color: #d2d000; display: block; padding:5px; padding-right: 10px;");
  catalogStore.fetchCatalog(sheetId.value, 'catalog')
  colorMode.preference = 'light'
  
  // Track initial pageview on mount
  trackPageview();


  (window as any).navigateToPage = navigateToPage;
})

const navigateToPage = (theroute: string) => {
  router.push(theroute);
}

// Track pageviews on route change
router.afterEach(() => {
  trackPageview()
})
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-leave-to {
  opacity: 0;
  
  transform: translateY(15px);
}
.page-enter-from {
  opacity: 0;
  
  transform: translateY(-15px);
}
</style>
